import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import IconBadge from "../../components/IconBadge";
import { homeIcons } from "./homeIcons";
import { coreServicesContent } from "./homeContent";
import "./HomeCoreServices.css";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

/* The certification-mark strip that used to close each card is gone (2026-09-13):
   the marks repeated information the checklist above them already carried, and
   they broke the card's rhythm by ending it on a row of mismatched bitmaps. The
   standards are now named in the list and nowhere else. `logoKeys` stays in
   homeContent.js — the Services page still renders it through
   components/CertificationLogos. */

const HomeCoreServices = () => (
  <section
    className="core-services bg-gray-50 py-14 lg:py-20"
    aria-labelledby="home-core-services-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="home-core-services-heading"
        title={coreServicesContent.title}
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-6 p-0 lg:grid-cols-2 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
      >
        {coreServicesContent.categories.map((category) => (
            <motion.li
              key={category.id}
              variants={cardVariants}
              className="brand-card core-services__card"
            >
              {/* the whole card opens the category's own page */}
              <Link
                to={category.to}
                className="block h-full p-6 lg:p-8 rounded-[inherit] text-inherit hover:text-inherit focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-orange)]"
              >
              <div className="flex items-center gap-4">
                {/* the client's navy + orange badge style (2026-09-25),
                    replacing the category illustration */}
                <IconBadge icon={homeIcons[category.icon]} size="md" />
                <h3 className="text-lg lg:text-xl font-bold text-gray-900">
                  {category.title}
                </h3>
              </div>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-gray-600">
                {category.intro}
              </p>
              <ul className="core-services__list mt-5 grid grid-cols-1 gap-x-6 gap-y-1 sm:grid-cols-2">
                {category.items.map((item) => (
                  <li key={item} className="core-services__item">
                    <FiCheckCircle
                      aria-hidden="true"
                      size={20}
                      className="core-services__tick"
                    />
                    <span className="text-sm md:text-base text-gray-700">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
              {category.outro && (
                <p className="mt-5 text-sm md:text-base leading-relaxed text-gray-600">
                  {category.outro}
                </p>
              )}
              </Link>
            </motion.li>
        ))}
      </motion.ul>
    </div>
  </section>
);

export default HomeCoreServices;
